import {Subject} from 'rxjs';
import {ENTRY_STATES} from '../../types/entry/EntryStatesEnum';
import {EntryWithState} from '../../types/entry/EntryWithStates';

export abstract class MessageStream<T extends EntryWithState> {

  // Observable message source
  private messageSource = new Subject<T>();

  // Observable message stream
  public messageSent$ = this.messageSource.asObservable();

  protected constructor() {}

  create() {
    this.messageSource.next({$state: ENTRY_STATES.NEW} as T);
  }

  modify(data: T) {
    data.$state = ENTRY_STATES.MODIFIED;
    this.messageSource.next(data);
  }

}
